import { SCREEN_SHARING_STREAM_NAME } from './constants'

export const getIsStreamIsScreenSharing = (stream: MediaStream) => {
  return !!stream.getVideoTracks().find(track => track.id.includes(SCREEN_SHARING_STREAM_NAME))
}
